module.exports = __webpack_public_path__ + "img/multi_rebalance.b26d6134.jpeg";